const _excluded = ["children", "close", "style", "isOpen"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { memo } from 'react';
import ReactModal from 'react-modal';
import { createGlobalStyle, css } from 'styled-components';
import { useThemeProviderStyles } from '@cbhq/cds-web/system/useThemeProviderStyles';
import { theme } from '../../styles/theme.js';
import { jsxs, jsx } from 'react/jsx-runtime';
const GlobalStyle = createGlobalStyle`${css`
  /* stylelint-disable-next-line selector-no-qualifying-type -- TODO Fix this */
  body.ReactModal__Body--open {
    overflow: hidden;
  }
  .ReactModal__Overlay {
    opacity: 0;
  }
  .ReactModal__Overlay--after-open {
    opacity: 1;
    transition: opacity 150ms;
  }
  .ReactModal__Content {
    -webkit-overflow-scrolling: touch;
  }
`}`;
const getModalStyles = (style = {}) => ({
  overlay: _objectSpread({
    backgroundColor: `${theme.color.maskDark}`,
    zIndex: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    overflow: 'scroll'
  }, style?.overlay && _objectSpread({}, style.overlay)),
  content: _objectSpread({
    padding: '0',
    zIndex: 110,
    outline: 'none',
    margin: 'auto 0px',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    position: 'initial'
  }, style?.content && _objectSpread({}, style.content))
});
function Modal(_ref) {
  let children = _ref.children,
    close = _ref.close,
    style = _ref.style,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen,
    restProps = _objectWithoutProperties(_ref, _excluded);
  const modalStyles = getModalStyles(style);
  const _useThemeProviderStyl = useThemeProviderStyles(),
    cdsCssVars = _useThemeProviderStyl.style,
    cdsClassName = _useThemeProviderStyl.className;
  return /*#__PURE__*/jsxs(ReactModal, _objectSpread(_objectSpread({
    isOpen: isOpen,
    portalClassName: cdsClassName,
    style: {
      // this maps CDS style variables to the modal div element
      content: Object.assign(modalStyles.content, cdsCssVars),
      overlay: modalStyles.overlay
    },
    onRequestClose: close
  }, restProps), {}, {
    children: [/*#__PURE__*/jsx(GlobalStyle, {}), children]
  }));
}
const Modal$1 = /*#__PURE__*/memo(Modal);
export { Modal, Modal$1 as default };
//# sourceMappingURL=Modal.js.map
